import { ThemeBase } from "../ThemeBase";
import polyfazerLegacyLogoTemplate from "./template/polyfazer-legacy-logo-template";
import styleSheet from "./styles/polyfazer-legacy-theme.css?inline";

/**
 * Polyfazer legacy (pre-2026 green brand)
 * ---
 * Kept whole and registered, but no environment points at it - it is the fallback if the rebrand
 * has to be rolled back for one environment or all of them. See ../README.md.
 *
 * Its palette is also still the app-wide default in public/index.css, so the stylesheet here is
 * a restatement rather than a set of overrides: it is what neutralises another theme, and it
 * keeps the legacy look pinned even if those defaults move on.
 */
export class PolyfazerLegacyTheme extends ThemeBase {
	static themeID = "polyfazer-legacy";

	/**
	 * @override
	 */
	get primaryColor() {
		return "#8bc34a";
	}

	/**
	 * @override
	 */
	get backgroundColor() {
		return "#f9f9f9";
	}

	/**
	 * @override
	 */
	get styleSheet() {
		return styleSheet;
	}

	/**
	 * @override
	 */
	get logoForMenu() {
		return this.getLogo(`style="width: 100%; height: 35px"`);
	}

	/**
	 * @override
	 */
	get logoForLoader() {
		return this.getLogo();
	}

	/**
	 * @override
	 */
	get chargingAnimationUrl() {
		return "/themes/polyfazer-legacy/assets/images/active.svg";
	}

	/**
	 * @override
	 */
	getLogo(attributes = '') {
		return polyfazerLegacyLogoTemplate(attributes);
	}
}

new PolyfazerLegacyTheme();
